import { AxiosResponse } from 'axios';
import { convertOrderStatusDtoToDomain, OrderStatus, OrderStatusDto } from '../features/settings/orderstatuses/OrderStatus';
import apiClient from './client';
import { ApiResponseDto } from '../interfaces/apiResponse';

interface OrderStatusesService {
  getOrderStatuses(): Promise<OrderStatus[]>;
  updateOrderStatus(updatedOrderStatus: OrderStatus): Promise<AxiosResponse<any>>;
}

const endpoints = {
  getOrderStatuses: '/order-statuses',
  updateOrderStatus: (id: number) =>`/order-statuses/${id}`,
}

export const orderStatusesService: OrderStatusesService = {
  getOrderStatuses: async (): Promise<OrderStatus[]> => {
    const response: AxiosResponse<ApiResponseDto<OrderStatusDto[]>> = await apiClient.get(endpoints.getOrderStatuses);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!.map((orderStatusDto: OrderStatusDto) => convertOrderStatusDtoToDomain(orderStatusDto));
  },

  updateOrderStatus: async (updatedOrderStatus: OrderStatus): Promise<AxiosResponse<any>> => {
    return apiClient.put(endpoints.updateOrderStatus(updatedOrderStatus.id), updatedOrderStatus);
  }
};
